module.exports = __webpack_public_path__ + "img/gn.3f4a6d5a.svg";